/**
 * Utility untuk mengambil data user dari localStorage
 * Menghindari circular dependency antara App.js dan routes.js
 */

export const getUserData = () => {
  const userStorage = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const userName =
    userStorage && userStorage.nama ? userStorage.nama.split(" ")[0] : "User";
  const userProfile =
    userStorage && userStorage.profil ? userStorage.profil : undefined;
  const userStatus =
    userStorage && userStorage.status ? userStorage.status : null;
  const userJenisPerusahaan =
    userStorage && userStorage.jenis_perusahaan
      ? userStorage.jenis_perusahaan
      : null;

  return {
    userStorage,
    userName,
    userProfile,
    userStatus,
    userJenisPerusahaan,
  };
};
